import store from '../store'
import * as MODULES from '../store/module-codes.js'

// Redirect to login if user becomes un authenticated
const checkAuth = async (to, from, next) => {
  try {
    if (store.state.auth.user){
      next()
    }
    else {
      next({ path: '/login', replace: true})
    }
  } catch (error){
    console.error(error.message)
    next({ path: '/login', replace: true})
  }
}


const Welcome = () => import('~/pages/hub/welcome').then(m => m.default || m)
const Login = () => import('~/pages/auth/login').then(m => m.default || m)
const Register = () => import('~/pages/auth/register').then(m => m.default || m)
const PasswordEmail = () => import('~/pages/auth/password/email').then(m => m.default || m)
const PasswordReset = () => import('~/pages/auth/password/reset').then(m => m.default || m)
const NotFound = () => import('~/pages/errors/404').then(m => m.default || m)

const Library = () => import('~/pages/hub/library').then(m => m.default || m)
const Settings = () => import('~/pages/settings/index').then(m => m.default || m)
// const SettingsProfile = () => import('~/pages/settings/profile').then(m => m.default || m)
// const SettingsPassword = () => import('~/pages/settings/password').then(m => m.default || m)
// const SettingsClass = () => import('~/pages/settings/class').then(m => m.default || m)
// const SettingsConsent = () => import('~/pages/settings/consent').then(m => m.default || m)

// Add modules here

const Documentation = () => import('~/pages/modules/documentation/index').then(m => m.default || m)
const Email = () => import('~/pages/modules/email/index').then(m => m.default || m)
const Chat = () => import('~/pages/modules/chat/chat').then(m => m.default || m)
const CUS = () => import('~/pages/modules/cus/cus').then(m => m.default || m)
// const Notes = () => import('~/pages/modules/notes/index').then(m => m.default || m)
// const AnalysisProgram = () => import('~/pages/modules/analysisProgram/index').then(m => m.default || m)
// const Evidence = () => import('~/pages/modules/evidenceLocker/index').then(m => m.default || m)
// const Side = () => import('~/pages/modules/sidebar/forensics').then(m => m.default || m)
// const QuickNotes = () => import('~/pages/modules/quickNotes/index').then(m => m.default || m)
const Tour = () => import('~/pages/modules/modals/tour').then(m => m.default || m)
const Video = () => import('~/pages/modules/modals/video').then(m => m.default || m)
const VideoCall = () => import('~/pages/modules/videoCall/index').then(m => m.default || m)
const Certificate = () => import('~/pages/modules/certificate/index').then(m => m.default || m)
const Terminal = () => import('~/pages/modules/terminal/index').then(m => m.default || m)

const CreatePCS = () => import('~/pages/modules/pcsCreator/index').then(m => m.default || m)

// const Maps = () => import('~/pages/modules/maps/index').then(m => m.default || m)
// const Table = () => import('~/pages/modules/table/index').then(m => m.default || m)
const RiskAssessment = () => import('~/pages/modules/riskAssessment/index').then(m => m.default || m)
const Cirt = () => import('~/pages/modules/cirt/index').then(m => m.default || m)
const Roles = () => import('~/pages/modules/roles/index').then(m => m.default || m)
const Dashboard = () => import('~/pages/modules/dashboard/index').then(m => m.default || m)
// const Graph = () => import('~/pages/modules/graph/index').then(m => m.default || m)
const TeamProfile = () => import('~/pages/modules/teamProfile/index').then(m => m.default || m)

const Teacher = () => import('~/pages/modules/admin/teacher').then(m => m.default || m)
const Admin = () => import('~/pages/modules/admin/admin').then(m => m.default || m)
const ClassMembers = () => import('~/pages/modules/admin/classComponents/StudentTable').then(m => m.default || m)
const ClassIndividualStudent = () => import('~/pages/modules/admin/classComponents/IndividualStudent').then(m => m.default || m)
const ClassGroups = () => import('~/pages/modules/admin/classComponents/GroupViewMode').then(m => m.default || m)
const ClassIndividualGroup = () => import('~/pages/modules/admin/classComponents/IndividualGroup').then(m => m.default || m)

const Survey = () => import('~/pages/modules/survey').then(m => m.default || m)
// const Store = () => import('~/pages/hub/store').then(m => m.default || m)
const About = () => import('~/pages/hub/about').then(m => m.default || m)
const PcsInfo = () => import('~/pages/hub/PcsInfo').then(m => m.default || m)
const ParksLanding = () => import('~/pages/landing/parks').then(m => m.default || m)
const Initiatives = () => import('~/components/Parks/ParksInitiatives.vue').then(m => m.default || m)
const RoleSelection = () => import('~/components/Parks/RoleSelection.vue').then(m => m.default || m)
const CollaborativeEditor = () => import('~/pages/modules/collaborativeEditor/index').then(m => m.default || m)
const IndividualEditor = () => import('~/pages/modules/individualEditor/index').then(m => m.default || m)

const Gameboard = () => import('~/pages/modules/gameboard/index').then(m => m.default || m)
const Animation = () => import('~/pages/modules/animation/index').then(m => m.default || m)

const ResearchConsent = () => import('~/pages/modules/researchConsent/index').then(m => m.default || m)
const VideoGameLanding = () => import('~/pages/landing/videoGameLanding').then(m => m.default || m)

const ClickableMap = () => import('~/pages/modules/clickableMap/index').then(m => m.default || m)

const UnitTest = () => import('~/pages/modules/unitTesting/index').then(m => m.default || m)

// End modules

export default [
  // Hub
  { path: '/', name: 'home', component: Welcome },
  { path: '/library', name: 'library', component: Library },
  { path: '/about', name: 'about', component: About },
  { path: '/PcsInfo/:id', name: 'PcsInfo', component: PcsInfo },

  { path: '/home/load_pcs', name: 'load_pcs', component: Library },
  { path: '/createPCS', name: 'create', components: { default: CreatePCS } },

  { path: '/login', name: 'login', component: Login },
  { path: '/register/:classCode?', name: 'register', component: Register },
  { path: '/password/reset', name: 'password.request', component: PasswordEmail },
  { path: '/password/reset/:token', name: 'password.reset', component: PasswordReset },

  //  Admin panel
  { path: '/admin', name: 'admin', component: Admin, beforeEnter: checkAuth },
  /* { path: '/store', name: 'store', component: Store }, */

  // Teacher panel
  { path: '/teacher', name: 'teacher', component: Teacher, beforeEnter: checkAuth },
  { path: '/class/members/:student_id', name: 'class.individual.student', component: ClassIndividualStudent, beforeEnter: checkAuth },
  { path: '/class/members', name: 'class.members', component: ClassMembers, beforeEnter: checkAuth },
  { path: '/class/groups/:group_id', name: 'class.individual.group', component: ClassIndividualGroup, beforeEnter: checkAuth },
  { path: '/class/groups', name: 'class.groups', component: ClassGroups, beforeEnter: checkAuth },
  
  
  // User settings
  {
    path: '/settings',
    component: Settings,
    name: 'settings',
    beforeEnter: checkAuth,
    // children: [
      // { path: '', name: 'settings', component: SettingsProfile, beforeEnter: checkAuth },
      // { path: 'password', name: 'settings.password', component: SettingsPassword, beforeEnter: checkAuth},
      // { path: 'class', name: 'settings.class', component: SettingsClass, beforeEnter: checkAuth },
      // { path: 'consent', name: 'settings.consent', component: SettingsConsent, beforeEnter: checkAuth }
    // ],
  },

    //  Parks and Recreation (Seneca)
  { path: '/roleSelection', name: 'parks.roleSelection', components: { default: RoleSelection }, beforeEnter: checkAuth, beforeEnter: checkAuth },
  { path: '/initiatives', name: 'parks.initiatives', components: { default: Initiatives }, beforeEnter: checkAuth},

  // Video game simulation 
  { path: '/cyclops', name: 'videoGameLanding', component: VideoGameLanding, beforeEnter: checkAuth },  

  // Add modules here
  { path: '/documentation', name: MODULES.DOCUMENTATION, components: { default: Documentation }, beforeEnter: checkAuth },
  { path: '/email', name: MODULES.EMAIL, components: { default: Email }, beforeEnter: checkAuth },
  { path: '/chat', name: MODULES.CHAT, components: { default: Chat, Modal: Video }, beforeEnter: checkAuth },
  { path: '/cus', name: MODULES.CUS, components: { default: CUS }, beforeEnter: checkAuth },
  { path: '/survey/:id?', name: MODULES.SURVEY, component: Survey, beforeEnter: checkAuth },
  { path: '/tour', name: MODULES.TOUR, components: { default: Dashboard, Modal: Tour }, beforeEnter: checkAuth },
  { path: '/dashboard', name: MODULES.DASHBOARD, components: { default: Dashboard, Modal: Video }, beforeEnter: checkAuth },
  { path: '/risk', name: MODULES.RISK, component: RiskAssessment, beforeEnter: checkAuth },
  { path: '/cirt', name: MODULES.CIRT, component: Cirt, beforeEnter: checkAuth },
  { path: '/collaborativeEditor', name: MODULES.COLLABORATIVE_EDITOR, component: CollaborativeEditor, beforeEnter: checkAuth },
  { path: '/individualEditor', name: MODULES.INDIVIDUAL_EDITOR, component: IndividualEditor, beforeEnter: checkAuth },
  { path: '/videoCall', name: MODULES.VIDEO_CALL, components: { default: VideoCall }, beforeEnter: checkAuth },
  { path: '/team', name: MODULES.TEAM_PROFILE, components: { default: TeamProfile }, beforeEnter: checkAuth },
  { path: '/roles', name: MODULES.ROLES, components: { default: Roles, Modal: Video }, beforeEnter: checkAuth},
  { path: '/seneca', name: 'parksLanding', component: ParksLanding, beforeEnter: checkAuth },
  { path: '/gameboard', name: MODULES.GAMEBOARD, components: { default: Gameboard }, beforeEnter: checkAuth },
  { path: '/animation', name: MODULES.ANIMATION, components: { default: Animation }, beforeEnter: checkAuth },
  { path: '/researchConsent', name: MODULES.RESEARCH_CONSENT, components: { default: ResearchConsent }, beforeEnter: checkAuth },
  { path: '/clickableMap', name: MODULES.CLICKABLE_MAP, components: { default: ClickableMap }, beforeEnter: checkAuth },
  { path: '/certificate', name: MODULES.CERTIFICATE, component: Certificate },
  { path: '/terminal', name: MODULES.TERMINAL, components: { default: Terminal }, beforeEnter: checkAuth },

  // Unit testing
  { path: '/unitTest', name: 'unit testing', component: UnitTest, beforeEnter: checkAuth },


  // Catch all
  { path: '*', component: NotFound },

  // Forensics
  // { path: '/Evidence', name: MODULES.EVIDENCE_LOCKER, components: { default: Evidence, side: Side, sideBottom: QuickNotes, Modal: Tour } },

  // Bronze Falls
  // { path: '/graph', name: 'bronzefalls.graph', components: { default: Graph, Modal: Tour } },
  // { path: '/maps', name: 'bronzefalls.maps', components: { default: Maps } },
  // { path: '/tables', name: 'bronzefalls.tables', components: { default: Table } },
]

